export interface PageTitleProps {
  /**
   * The title of the page
   */
  title: string;
  /**
   * Optional description to display below the title
   */
  description?: string;
  /**
   * Optional className for the title container
   */
  className?: string;
}

export function PageTitle({
  title,
  description,
  className = "",
}: Readonly<PageTitleProps>) {
  return (
    <div className={`space-y-1 ${className}`}>
      <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
      {description && <p className="text-muted-foreground">{description}</p>}
    </div>
  );
}
